import { differenceInYears, format } from "date-fns";
import { useQuery } from "@tanstack/react-query";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { getUsers } from "../../services/user.service";
import CustomTable from "../../components/CustomTable";
import { StyledTableCell } from "../../components/styled";
import { Box, IconButton, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { downloadUsers } from "../../services/user.service";
import { DATE_TIME_FORMAT } from "../../utils/constants";

const renderHeader = () => (
  <TableRow>
    <StyledTableCell>Id</StyledTableCell>
    <StyledTableCell>Username</StyledTableCell>
    <StyledTableCell>Display Name</StyledTableCell>
    <StyledTableCell>Verified as</StyledTableCell>
    <StyledTableCell>Date of Birth</StyledTableCell>
    <StyledTableCell>Created Date</StyledTableCell>
    <StyledTableCell>Action</StyledTableCell>
  </TableRow>
);

const renderRow = (user) => (
  <TableRow key={user.id}>
    <TableCell>{user.id}</TableCell>
    <TableCell>{user.username ? `@${user.username}` : ""}</TableCell>
    <TableCell>{user.name}</TableCell>
    <TableCell>{user.verifiedAs || "-"}</TableCell>
    <TableCell>
      {user.birthday
        ? `${format(user.birthday, "MMM d, yyyy")} (${differenceInYears(new Date(), new Date(user.birthday))} years old)`
        : "N/A"}
    </TableCell>
    <TableCell>{format(user.createdDate, DATE_TIME_FORMAT)}</TableCell>
    <TableCell>
      <IconButton aria-label="view" component={Link} to={`${user.id}`}>
        <VisibilityIcon />
      </IconButton>
    </TableCell>
  </TableRow>
);

const Users = () => {
  const { isLoading: isDownloading } = useQuery({
    queryKey: ["download"],
    queryFn: () => downloadUsers(),
    enabled: false,
  });

  const onDownload = () => {
    downloadUsers();
  };

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <IconButton
          aria-label={"download"}
          onClick={onDownload}
          edge="end"
          disabled={isDownloading}
        >
          {isDownloading ? (
            <CircularProgress size={24} />
          ) : (
            <DownloadIcon size={24} />
          )}
        </IconButton>
      </Box>

      <CustomTable
        name={"users"}
        getItemsMethod={getUsers}
        renderHeader={renderHeader}
        renderRow={renderRow}
        columnCount={7}
        searchLabel={"Search by Display Name"}
        isSearchable
      />
    </>
  );
};

export default Users;
